import { Actions, helper } from '@appbaseio/reactivecore';
import { a as _extends } from './_rollupPluginBabelHelpers-0f24d612.js';
import VueTypes from 'vue-types';
import { componentTypes } from '@appbaseio/reactivecore/lib/utils/constants';
import 'emotion';
import '@appbaseio/vue-emotion';
import 'polished';
import { t as types } from './vueTypes-e89c8a3c.js';
import '@appbaseio/reactivecore/lib/utils/transform';
import 'redux';
import { f as updateCustomQuery, u as updateDefaultQuery, i as isQueryIdentical, a as isFunction, g as getComponent, n as isEvent, h as hasCustomRenderer, c as connect } from './index-cb1950b6.js';
import { C as ComponentWrapper } from './ComponentWrapper-4f85a67e.js';
import { T as Title } from './Title-3522ff56.js';
import { I as Input } from './Input-08bb1bcf.js';
import { C as Container } from './Container-18b03fde.js';
import { U as UL, R as Radio } from './FormControlList-704f8dee.js';
import { g as getAggsQuery } from './utils-64a2e5f0.js';

var updateQuery = Actions.updateQuery,
    setQueryOptions = Actions.setQueryOptions,
    setCustomQuery = Actions.setCustomQuery,
    setDefaultQuery = Actions.setDefaultQuery;
var getQueryOptions = helper.getQueryOptions,
    checkValueChange = helper.checkValueChange,
    getClassName = helper.getClassName,
    getOptionsFromQuery = helper.getOptionsFromQuery,
    isEqual = helper.isEqual;
var SingleList = {
  name: 'SingleList',
  props: {
    beforeValueChange: types.func,
    className: types.string.def(''),
    componentId: types.stringRequired,
    customQuery: types.func,
    dataField: types.stringRequired,
    defaultValue: types.string,
    value: types.value,
    defaultQuery: types.func,
    filterLabel: types.string,
    innerClass: types.style,
    placeholder: VueTypes.string.def('Search'),
    react: types.react,
    render: types.func,
    renderItem: types.func,
    renderNoResults: VueTypes.any,
    transformData: types.func,
    selectAllLabel: types.string,
    showCount: VueTypes.bool.def(true),
    showFilter: VueTypes.bool.def(true),
    showRadio: VueTypes.bool.def(true),
    showSearch: VueTypes.bool.def(true),
    size: VueTypes.number.def(100),
    sortBy: VueTypes.oneOf(['asc', 'desc', 'count']).def('count'),
    title: types.title,
    URLParams: VueTypes.bool.def(false),
    showMissing: VueTypes.bool.def(false),
    missingLabel: VueTypes.string.def('N/A'),
    nestedField: types.string,
    index: VueTypes.string,
    enableStrictSelection: VueTypes.bool.def(false)
  },
  data: function data() {
    var props = this.$props;
    this.__state = {
      currentValue: '',
      modifiedOptions: [],
      searchTerm: ''
    };
    this.internalComponent = props.componentId + "__internal";
    return this.__state;
  },
  created: function created() {
    if (!this.enableAppbase && this.$props.index) {
      console.warn('Warning(ReactiveSearch): In order to use the `index` prop, the `enableAppbase` prop must be set to true in `ReactiveBase`.');
    }

    var props = this.$props;
    this.modifiedOptions = this.options && this.options[props.dataField] ? this.options[props.dataField].buckets : []; // Set custom and default queries in store

    updateCustomQuery(this.componentId, this.setCustomQuery, this.$props, this.currentValue);
    updateDefaultQuery(this.componentId, this.setDefaultQuery, this.$props, this.currentValue);
  },
  beforeMount: function beforeMount() {
    this.updateQueryHandlerOptions(this.$props);

    if (this.selectedValue) {
      this.setValue(this.selectedValue);
    } else if (this.$props.value) {
      this.setValue(this.$props.value);
    } else if (this.$props.defaultValue) {
      this.setValue(this.$props.defaultValue);
    }
  },
  watch: {
    options: function options(newVal) {
      if (newVal) {
        this.modifiedOptions = newVal[this.$props.dataField] ? newVal[this.$props.dataField].buckets : [];
      }
    },
    size: function size() {
      this.updateQueryHandlerOptions(this.$props);
    },
    sortBy: function sortBy() {
      this.updateQueryHandlerOptions(this.$props);
    },
    dataField: function dataField() {
      this.updateQueryHandlerOptions(this.$props);
      this.updateQueryHandler(this.$data.currentValue, this.$props);
    },
    defaultValue: function defaultValue(newVal) {
      this.setValue(newVal);
    },
    value: function value(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.setValue(newVal);
      }
    },
    selectedValue: function selectedValue(newVal) {
      if (this.$data.currentValue !== newVal) {
        this.setValue(newVal || '');
      }
    },
    defaultQuery: function defaultQuery(newVal, oldVal) {
      if (!isQueryIdentical(newVal, oldVal, this.$data.currentValue, this.$props)) {
        this.updateDefaultQueryHandler(this.$data.currentValue, this.$props);
      }
    },
    customQuery: function customQuery(newVal, oldVal) {
      if (!isQueryIdentical(newVal, oldVal, this.$data.currentValue, this.$props)) {
        this.updateQueryHandler(this.componentId, this.$data.currentValue, this.$props);
      }
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var _this$$props = this.$props,
        selectAllLabel = _this$$props.selectAllLabel,
        renderItem = _this$$props.renderItem,
        renderError = _this$$props.renderError;
    var renderItemCalc = this.$scopedSlots.renderItem || renderItem;
    var renderErrorCalc = this.$scopedSlots.renderError || renderError;

    if (renderErrorCalc && this.error) {
      return isFunction(renderErrorCalc) ? renderErrorCalc(this.error) : renderErrorCalc;
    }

    if (!this.hasCustomRenderer && this.modifiedOptions.length === 0 && !this.isLoading) {
      if (this.renderNoResult) {
        this.renderNoResult();
      } else {
        return null;
      }
    }

    var itemsToRender = this.$data.modifiedOptions;

    if (this.$props.transformData) {
      itemsToRender = this.$props.transformData(itemsToRender);
    }

    var filteredItemsToRender = itemsToRender.filter(function (item) {
      if (String(item.key).length) {
        if (_this.$props.showSearch && _this.$data.searchTerm) {
          return String(item.key).toLowerCase().includes(_this.$data.searchTerm.toLowerCase());
        }

        return true;
      }

      return false;
    });
    return h(Container, {
      "class": this.$props.className
    }, [this.$props.title && h(Title, {
      "class": getClassName(this.$props.innerClass, 'title') || ''
    }, [this.$props.title]), this.renderSearch(), this.hasCustomRenderer ? this.getComponent() : h(UL, {
      "class": getClassName(this.$props.innerClass, 'list') || ''
    }, [selectAllLabel ? h("li", {
      "key": selectAllLabel,
      "class": "" + (this.$data.currentValue === selectAllLabel ? 'active' : '')
    }, [h(Radio, {
      "class": getClassName(this.$props.innerClass, 'radio'),
      "attrs": {
        "id": this.$props.componentId + "-" + selectAllLabel,
        "name": this.$props.componentId,
        "value": selectAllLabel,
        "readOnly": true,
        "show": this.$props.showRadio
      },
      "on": {
        "click": this.handleClick
      },
      "domProps": _extends({}, {
        checked: this.$data.currentValue === selectAllLabel
      })
    }), h("label", {
      "class": getClassName(this.$props.innerClass, 'label') || null,
      "attrs": {
        "for": this.$props.componentId + "-" + selectAllLabel
      }
    }, [selectAllLabel])]) : null, !this.hasCustomRenderer && filteredItemsToRender.length === 0 && !this.isLoading ? this.renderNoResult() : filteredItemsToRender.map(function (item) {
      return h("li", {
        "key": item.key,
        "class": "" + (_this.currentValue === String(item.key) ? 'active' : '')
      }, [h(Radio, {
        "class": getClassName(_this.$props.innerClass, 'radio'),
        "attrs": {
          "id": _this.$props.componentId + "-" + item.key,
          "name": _this.$props.componentId,
          "value": item.key,
          "readOnly": true,
          "type": "radio",
          "show": _this.$props.showRadio
        },
        "on": {
          "click": _this.handleClick
        },
        "domProps": _extends({}, {
          checked: _this.currentValue === String(item.key)
        })
      }), h("label", {
        "class": getClassName(_this.$props.innerClass, 'label') || null,
        "attrs": {
          "for": _this.$props.componentId + "-" + item.key
        }
      }, [renderItemCalc ? renderItemCalc({
        label: item.key,
        count: item.doc_count,
        isChecked: _this.currentValue === String(item.key)
      }) : h("span", [item.key, _this.$props.showCount && h("span", {
        "class": getClassName(_this.$props.innerClass, 'count') || null
      }, ["\xA0(", item.doc_count, ")"])])])]);
    })])]);
  },
  methods: {
    setValue: function setValue(nextValue, props) {
      var _this2 = this;

      if (props === void 0) {
        props = this.$props;
      }

      var value = nextValue;

      if (nextValue === this.$data.currentValue) {
        value = '';
      }

      var performUpdate = function performUpdate() {
        _this2.currentValue = value;

        _this2.updateQueryHandler(value, props);

        _this2.$emit('valueChange', value);

        _this2.$emit('value-change', value);
      };

      checkValueChange(props.componentId, value, props.beforeValueChange, performUpdate);
    },
    updateDefaultQueryHandler: function updateDefaultQueryHandler(value, props) {
      var defaultQueryOptions;
      var query = SingleList.defaultQuery(value, props);

      if (this.defaultQuery) {
        var defaultQueryToBeSet = this.defaultQuery(value, props) || {};

        if (defaultQueryToBeSet.query) {
          query = defaultQueryToBeSet.query;
        }

        defaultQueryOptions = getOptionsFromQuery(defaultQueryToBeSet); // Update calculated default query in store

        updateDefaultQuery(props.componentId, this.setDefaultQuery, props, value);
      }

      this.setQueryOptions(this.internalComponent, defaultQueryOptions);
      this.updateQuery({
        componentId: this.internalComponent,
        query: query,
        value: value,
        componentType: componentTypes.singleList
      });
    },
    updateQueryHandler: function updateQueryHandler(value, props) {
      var customQuery = props.customQuery;
      var query = SingleList.defaultQuery(value, props);
      var customQueryOptions;

      if (customQuery) {
        var _ref = customQuery(value, props) || {};

        query = _ref.query;
        customQueryOptions = getOptionsFromQuery(customQuery(value, props));
        updateCustomQuery(props.componentId, this.setCustomQuery, props, value);
      }

      this.setQueryOptions(props.componentId, customQueryOptions);
      this.updateQuery({
        componentId: props.componentId,
        query: query,
        value: value,
        label: props.filterLabel,
        showFilter: props.showFilter,
        URLParams: props.URLParams,
        componentType: componentTypes.singleList
      });
    },
    generateQueryOptions: function generateQueryOptions(props) {
      var queryOptions = getQueryOptions(props);
      return getAggsQuery(queryOptions, props);
    },
    updateQueryHandlerOptions: function updateQueryHandlerOptions(props) {
      var queryOptions = SingleList.generateQueryOptions(props);

      if (props.defaultQuery) {
        var value = this.$data.currentValue;
        var defaultQueryOptions = getOptionsFromQuery(props.defaultQuery(value, props));
        this.setQueryOptions(this.internalComponent, _extends({}, queryOptions, defaultQueryOptions));
      } else {
        this.setQueryOptions(this.internalComponent, queryOptions);
      }
    },
    handleInputChange: function handleInputChange(e) {
      var value = e.target.value;
      this.searchTerm = value;
    },
    renderSearch: function renderSearch() {
      var h = this.$createElement;

      if (this.$props.showSearch) {
        return h(Input, {
          "class": getClassName(this.$props.innerClass, 'input') || '',
          "on": {
            "input": this.handleInputChange
          },
          "attrs": {
            "value": this.$data.searchTerm,
            "placeholder": this.$props.placeholder,
            "themePreset": this.$props.themePreset
          },
          "style": {
            margin: '0 0 8px'
          }
        });
      }

      return null;
    },
    getComponent: function getComponent$1() {
      var _this$$data = this.$data,
          currentValue = _this$$data.currentValue,
          modifiedOptions = _this$$data.modifiedOptions;
      var transformData = this.$props.transformData;
      var itemsToRender = modifiedOptions;

      if (transformData) {
        itemsToRender = transformData(itemsToRender);
      }

      var data = {
        error: this.error,
        loading: this.isLoading,
        value: currentValue,
        data: itemsToRender,
        rawData: this.rawData,
        handleChange: this.handleClick
      };
      return getComponent(data, this);
    },
    handleClick: function handleClick(e) {
      var currentValue = e;

      if (isEvent(e)) {
        currentValue = e.target.value;
      }

      if (this.enableStrictSelection && currentValue === this.currentValue) {
        return false;
      }

      var value = this.$props.value;

      if (value === undefined) {
        this.setValue(currentValue);
      } else {
        this.$emit('change', currentValue);
      }

      return true;
    },
    renderNoResult: function renderNoResult() {
      var h = this.$createElement;
      var renderNoResults = this.$scopedSlots.renderNoResults || this.$props.renderNoResults;
      return h("p", {
        "class": getClassName(this.$props.innerClass, 'noResults') || null
      }, [isFunction(renderNoResults) ? renderNoResults() : renderNoResults]);
    }
  },
  computed: {
    hasCustomRenderer: function hasCustomRenderer$1() {
      return hasCustomRenderer(this);
    }
  }
};

SingleList.generateQueryOptions = function (props) {
  var queryOptions = getQueryOptions(props);
  return getAggsQuery(queryOptions, props);
};

SingleList.defaultQuery = function (value, props) {
  var query = null;

  if (props.selectAllLabel && props.selectAllLabel === value) {
    if (props.showMissing) {
      query = {
        match_all: {}
      };
    }

    query = {
      exists: {
        field: props.dataField
      }
    };
  }

  if (value) {
    var _term;

    query = {
      term: (_term = {}, _term[props.dataField] = value, _term)
    };

    if (props.showMissing && props.missingLabel === value) {
      query = {
        bool: {
          must_not: {
            exists: {
              field: props.dataField
            }
          }
        }
      };
    }
  }

  if (query && props.nestedField) {
    return {
      query: {
        nested: {
          path: props.nestedField,
          query: query
        }
      }
    };
  }

  return query;
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    options: props.nestedField && state.aggregations[props.componentId] ? state.aggregations[props.componentId].reactivesearch_nested : state.aggregations[props.componentId],
    rawData: state.rawData[props.componentId],
    isLoading: state.isLoading[props.componentId],
    selectedValue: state.selectedValues[props.componentId] && state.selectedValues[props.componentId].value || '',
    themePreset: state.config.themePreset,
    error: state.error[props.componentId],
    componentProps: state.props[props.componentId],
    enableAppbase: state.config.enableAppbase
  };
};

var mapDispatchtoProps = {
  setQueryOptions: setQueryOptions,
  updateQuery: updateQuery,
  setCustomQuery: setCustomQuery,
  setDefaultQuery: setDefaultQuery
};
var ListConnected = ComponentWrapper(connect(mapStateToProps, mapDispatchtoProps)(SingleList), {
  componentType: componentTypes.singleList,
  internalComponent: true
});

SingleList.install = function (Vue) {
  Vue.component(SingleList.name, ListConnected);
}; // Add componentType for SSR


SingleList.componentType = componentTypes.singleList;

export default SingleList;
